import React from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';

function CommunityGuidelines() {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <Link to="/" className="back-link">
          ← トップに戻る
        </Link>
        <h1>コミュニティガイドライン</h1>
      </div>

      <div className="terms-content">
        <section className="terms-section">
          <p className="section-intro">
            ヤマッチは、安心して登山仲間とつながり、安全な山行を実現するためのサービスです。
            すべての利用者が安心して利用できるよう、以下のガイドラインを守ってください。
          </p>

          <div className="terms-article">
            <h3>1. 基本方針</h3>
            <ul>
              <li>登山は自然環境下で行われる危険を伴う活動です。</li>
              <li>募集者は計画責任者として、難易度、標準CT、装備条件、集合・解散方法を明確にしてください。</li>
              <li>参加者は自身の体力、経験、装備、当日の体調を踏まえ、自己責任で参加可否を判断してください。</li>
              <li>相手への敬意と安全配慮を最優先してください。</li>
            </ul>
          </div>

          <div className="terms-article">
            <h3>2. 禁止行為</h3>
            <ul>
              <li>暴力、脅迫、誹謗中傷、嫌がらせ</li>
              <li>危険な登山計画・行動の強要、無謀な計画の募集</li>
              <li>ナンパ・恋愛目的の勧誘、登山と無関係な出会い目的の利用</li>
              <li>個人情報の無断収集、共有、悪用</li>
              <li>なりすまし、虚偽情報の登録、経歴や実績の詐称</li>
              <li>ドタキャン、迷惑行為の繰り返し</li>
              <li>外部サービスへの過度な誘導、スパム、商用勧誘</li>
              <li>法令または公序良俗に反する行為</li>
            </ul>
          </div>

          <div className="terms-article">
            <h3>3. 安全に関するルール</h3>
            <ul>
              <li>初心者向けでない山行では、経験・装備・撤退判断を事前に確認してください。</li>
              <li>登山計画書の提出、天候確認、装備確認を忘れずに行ってください。</li>
              <li>危険を感じた場合は、集合前・行動中を問わず無理に参加や続行をしないでください。</li>
              <li>集合・解散、車移動、相乗り条件は事前に明確にしてください。</li>
            </ul>
          </div>

          <div className="terms-article">
            <h3>4. 非公開情報とスクリーンショット</h3>
            <ul>
              <li>相手から公開された非公開プロフィール情報を、目的外に利用しないでください。</li>
              <li>チャット内容、プロフィール、募集内容のスクリーンショットや転載は禁止します。</li>
              <li>相手の同意なく個人情報を第三者へ共有しないでください。</li>
            </ul>
          </div>

          <div className="terms-article">
            <h3>5. 通報と運営対応</h3>
            <p>
              不適切な行為を見つけた場合は、通報機能またはお問い合わせからご連絡ください。
              通報内容は運営が確認し、必要に応じて注意、機能制限、一時停止、アカウント停止を行います。
            </p>
            <p>
              暴力・脅迫、危険な登山計画・行動など安全上重大な通報については、一次対応として機能制限を行う場合があります。
            </p>
          </div>

          <div className="terms-article">
            <h3>6. 最後に</h3>
            <p>
              ヤマッチは、利用者同士の信頼で成り立つ登山コミュニティです。
              無理をしない、正直に伝える、相手を尊重する。この3つを大切にしてください。
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default CommunityGuidelines;
